(function () {
  'use strict';

  angular.module('wsLrs.controllers').controller('YourOrganizationHeaderCtrl', ['$scope', '$window', function ($scope, $window) {
    $scope.back = function () {
      $window.history.back();
    };
  }]).controller('ExploreYourOrganizationCtrl', ['$http', '$location', '$q', '$scope', '$uibModalInstance', '$window', 'Api', function ($http, $location, $q, $scope, $uibModalInstance, $window, Api) {
    $scope.selectedNode = null;
    $scope.hierarchyData = {
      // chart config data
      data: null,
      loading: true
    };

    // Hierarchy chart configuration options
    var clickFn = function clickFn(node) {
      $scope.cancel();
      // when node clicked, redirect to that node's groups page
      $location.path('/settings/groups/' + node.id);
    };
    var layoutOpts = {
      heightFactor: 0.67,
      // fraction of available height to use for initial tree height
      widthScale: 5.6,
      // scale factor to convert label length (chars) to tree level width (pixel)
      widthPadding: 75,
      // extra space added to level width when only 1 label between layers
      nodeSpacing: {
        min: 18,
        max: 75
      },
      // vertical spacing between nodes
      levelWidth: {
        min: 80,
        max: 1000
      },
      // horizontal spacing between tree treeLayout
      maxFanOutRatio: 10.0,
      // max ratio of fanOut to width
      zoomLevel: {
        min: 0.1,
        max: 3.0,
        initial: null
      } // zoom level extents
    };
    var tooltipLabel = function tooltipLabel(node) {
      var people = node.people || [];
      var text = people.length > 0 ? 'Click to view <b>' + people.length + '</b> members of' : 'Click to view the settings for';
      return '<span style="font-size: smaller">' + text + '</span><br>' + '<b>' + node.name + '</b> - (' + node.type.name + ')';
    };
    var hierarchyDataOptions = {
      clickFn: clickFn,
      layoutOpts: layoutOpts,
      tooltipLabel: tooltipLabel
    };
    var setHierarchyData = function setHierarchyData(data) {
      var hierarchyData = {
        data: data ? data : $scope.hierarchyData.data,
        isResize: data ? false : true
      };
      return _.extend(hierarchyData, hierarchyDataOptions);
    };
    $scope.rootNodes = null;
    $http.get(Api.url("/groups"), {
      params: {
        rootOnly: true,
        parentOnly: true
      }
    }).then(function (response) {
      $scope.rootNodes = response.data.results;
      if ($scope.rootNodes.length) {
        // todo: pick initial node based on depth
        $scope.selectedNode = _.sortBy($scope.rootNodes, 'name')[0];
        $scope.renderChart($scope.selectedNode);
      }
    });
    $scope.renderChart = function (rootNode) {
      $scope.hierarchyData = {
        data: null,
        isResize: false,
        loading: true
      };

      // abort a previous render request
      if ($scope.deferredAbort) {
        $scope.deferredAbort.resolve("Previous request cancelled by new request.");
      }

      // create the request, passing deferredAbort promise as the 'timeout' param
      $scope.deferredAbort = $q.defer();
      $http.get(Api.url("/groups/" + rootNode.id), {
        params: {
          childDepth: -1
        },
        timeout: $scope.deferredAbort.promise
      }
      // onResolved handler
      ).then(function (response) {
        // rename childGroups property as 'children'
        var stack = [response.data];
        while (stack.length) {
          var cur = stack.pop();
          cur.children = cur.childGroups;
          delete cur.childGroups;
          stack = stack.concat(cur.children);
        }
        resizeChart(response.data);
        // clear deferredAbort whether resolved or rejected
      }).finally(function () {
        $scope.deferredAbort = null;
      });
    };

    // maximize the modal window by sizing the chart div
    // no need to pass height in config data - it will get its height from the chart div
    // setting the div height ensures both the div and the svg content are
    // the same height, as well as allowing the CSS min-height to be enforced
    function resizeChart(data) {
      var modalDialog, chartDiv;
      if ((chartDiv = $('#org-hierarchy').get(0)) && (modalDialog = $(chartDiv).closest('.modal-dialog'))) {
        // size the chart so that modal outerHeight will fill the window height
        var h = $($window).height() - ($(modalDialog).outerHeight(true) - chartDiv.offsetHeight);
        $(chartDiv).height(h);
        // reset hierarchyData to trigger re-render in directive
        $scope.hierarchyData = setHierarchyData(data);
      }
    }

    //resizeChart when window inner height changes
    $scope.$watch(function () {
      return $($window).height();
    }, function () {
      resizeChart();
    });

    // put any close/dismiss processing here to catch dismissal via ESC key
    $uibModalInstance.result.then(function modalClosed() {}, function modalDismissed() {
      // when modal dismissed, remove exploreModal from the path
      $location.search('explore', null);
    });
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]);
})();
